import { useGetSupportContactsQuery } from "features/Support/api/supportApi.ts";
import ErrorBanner from "components/Common/ErrorBanner/ErrorBanner.tsx";
import ContactCards from "../components/ContactCards/ContactCards.tsx";
import SupportCases from "../components/SupportCases/SupportCases.tsx";
import * as Styles from "./SupportPage.styles.ts";

const SupportPage = () => {
	const { data, isLoading, isError } = useGetSupportContactsQuery();

	const contacts = (data?.contacts ?? []).filter(
		(contact) => contact.type !== "DESIGN_SUPPORT" || data?.hasDesignerServices === true
	);

	return (
		<Styles.Page data-testid="support-page">
			<Styles.Header>
				<Styles.Title>Contact Us</Styles.Title>
			</Styles.Header>

			<Styles.Content>
				{isLoading && (
					<Styles.ContactSkeletonGrid data-testid="support-contacts-loading">
						{[0, 1, 2, 3].map((item) => (
							<Styles.ContactSkeleton
								key={item}
								variant="rectangular"
							/>
						))}
					</Styles.ContactSkeletonGrid>
				)}

				{isError && (
					<ErrorBanner errorMessaging="Unable to load contact information. Please try again later." />
				)}

				{!isLoading &&
					!isError &&
					(contacts.length === 0 ? (
						<Styles.EmptyMessage>No contact information is currently available.</Styles.EmptyMessage>
					) : (
						<ContactCards contacts={contacts} />
					))}

				<SupportCases />
			</Styles.Content>
		</Styles.Page>
	);
};

export default SupportPage;
